import { generateStreamlitLinkCloudFunction } from '@/firebase/init';
import { ConnectorsService } from '@/services/connectorsService';
import { useDashboardSidebarStore } from '@/stores/dashboardsSidebarStore';
import { useOrganizationStore } from '@/stores/organizationStore';
import { assert } from '@/utils/asserts';
import { LoaderFunctionArgs, useLoaderData } from 'react-router-dom';

export function Streamlit() {
  const { link } = useLoaderData() as { link: string };

  return (
    <div style={{ width: '100%', display: 'flex', height: '100%' }}>
      <iframe style={{ width: '100%' }} title="streamlit" src={link} />
    </div>
  );
}

export async function streamlitLoader({ request, params }: LoaderFunctionArgs) {
  const dashboardName = params.dashboardId;
  const url = new URL(request.url);
  const workspaceId = url.searchParams.get('workspaceId');
  const selectedOrganization = useOrganizationStore.getState().selectedOrganization;
  const organizationId = selectedOrganization?.id;

  assert(workspaceId, 'workspaceId is required');
  assert(organizationId, 'organizationId is required');
  assert(dashboardName, 'dashboardId is required');

  const exceptionOrganizationId = '20itorx436o4vkxprnfhz';

  let report;

  if (selectedOrganization.id !== exceptionOrganizationId) {
    report = dashboardName === 'general' ? 'performancemarketingsummary' : dashboardName;
  }

  const link = await generateStreamlitLinkCloudFunction({
    organizationId,
    workspaceId,
    report,
  });

  return { link: link.data };
}

export async function streamlitRootLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const workspaceId = url.searchParams.get('workspaceId');
  assert(workspaceId, 'workspaceId is required');
  const dataforseoConnector = await ConnectorsService.getConnector(
    workspaceId,
    'dataforseo',
  );
  if (dataforseoConnector) {
    useDashboardSidebarStore.getState().setIsDataforseo(true);
  } else {
    useDashboardSidebarStore.getState().setIsDataforseo(false);
  }
  return {};
}
